export const environmentBase = {
    name: 'MEMBER APPLICATION'
};
